import { ReactComponent as YoutubeColorLight } from 'fym-shared/src/music-services/assets/images/youtube-color-light.svg';
import { ReactComponent as YoutubeColorDark } from 'fym-shared/src/music-services/assets/images/youtube-color-dark.svg';
import { ReactComponent as YoutubeColorLightPadding } from 'fym-shared/src/music-services/assets/images/youtube-color-light-padding.svg';
import { ReactComponent as YoutubeColorDarkPadding } from 'fym-shared/src/music-services/assets/images/youtube-color-dark-padding.svg';
import { MusicServiceImages } from './types';

export const youtubeImages: MusicServiceImages = {
  logoColor: {
    light: YoutubeColorLight,
    dark: YoutubeColorDark,
  },
  logoColorPadding: {
    light: YoutubeColorLightPadding,
    dark: YoutubeColorDarkPadding,
  },
};
